define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/store/_base",
	"csi/store/Names",
	"csi/types",
	"csi/xml",
	"csi/xml/Query",
	"Specification/BOM/BOMSectionMixin",
	"Specification"
], function(declare, lang, def, Field, Relationship, FormWidget, csi_store, Names, types, xml, Query, BOMSectionMixin, Specification) {

	return declare([FormWidget, BOMSectionMixin], {
		FIELD_MATERIAL_NAME: "MaterialName",
		FIELD_SECTION: "BomSection",
		FIELD_SEASON: "SeasonName",
		FIELD_TARGET_FOOD_TYPE: "FoodSubtype",
		FIELD_TARGET_MATERIAL_TYPE: "MaterialType",
		PART_MATERIAL_FIELDS: "PartMaterialFields",
		SEARCH_FIELDS: "SearchFields",

		_getStore: function(/*Relationship*/r) {
			// summary: get store given relationship
			var storeOptions = {data: [csi_store.nameObject("")]};
			csi_store.namesOptionsByRelationship(this.getContext(), r, storeOptions);
			return new Names(storeOptions);
		},

		_getMaterialStore: function() {
			var MTQuery = new Query() //"Material Type" drop-down should only display material types that support a BOM and are associated with the section definition
				.Attr2("TDSMap", xml.OP_EQUALS, {
					Path: "Child:ProductionConfig",
					Index: "MaterialBOM",
					SValue: true
				});

			// if a BOM section is selected that has a restriction on BOMProductTypes, then apply it
			var selectedSection = this.defView.getFieldValue(this.FIELD_SECTION);

			this.applyBomSectionQuery(selectedSection, MTQuery, this.cacheView, true);

			var storeMT = this._getStore(lang.mixin(new Relationship(), {
				m_typeNode: "MaterialType",
				m_query: MTQuery
			}));

			return storeMT;
		},

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			// summary: if field is for Product or Supplier, add SelectAll option
			var name = field.getControlName();
			if (name == this.FIELD_SECTION) {
				const actionCtx = {
					isApparelBOMAction: this._isApparelBOMAction,
					isFoodBOMAction: this._isFoodBOMAction,
					isThemeBOMAction: this._isThemeBOMAction
				};

				return this.getBOMSectionStore(actionCtx, this.getFormData().getSource().m_urlParent);
			}

			if (name == this.FIELD_TARGET_MATERIAL_TYPE) {
				return this._getMaterialStore();
			}

			return this.inherited(arguments);
		},

		onChangeSection: function(/*csi.def.View*/formView, /*csi.def.Field*/field, /*Any*/value) {
			// summary: when Section field changes, reset the To selection store (on Material BOM tab)
			var self = this;
			this.when(this.cacheView.getNodeDeferred(value), function(sectionNode) {
				var fieldTo = formView.getField(self.FIELD_TARGET_MATERIAL_TYPE);
				if (fieldTo)
					fieldTo.m_control.set("store", self._getMaterialStore());
			});
		},

		_resolveView: function() {
			var sourceViewId = this.getFormData().getSource().widget.defView.m_id;
			this._isApparelBOMAction = sourceViewId == "WhereUsedApparelBOM";
			this._isFoodBOMAction = sourceViewId == "WhereUsedFoodBOM";
			this._isThemeBOMAction = sourceViewId == "WhereUsedThemeBOM";
			var fieldLabel;

			var relationship;
			if (this._isApparelBOMAction || this._isThemeBOMAction) {
				fieldLabel = this.FIELD_SEASON;
				relationship = lang.mixin(new Relationship(), {
					m_typeNode: "Season",
					m_query: new Query()
						.Attr("Active", xml.OP_EQUALS, true)
				});
			} else if (this._isFoodBOMAction) {
				fieldLabel = this.FIELD_TARGET_FOOD_TYPE;
				// Only display FoodSubtypes that have Food BOM
				relationship = lang.mixin(new Relationship(), {
					m_typeNode: "FoodSubtype",
					m_query: new Query()
						.Attr("TDSList", xml.OP_EQUALS, "FoodTypeDataSheet:FoodBOM", "Child:Settings")
				})
			} else {
				fieldLabel = this.FIELD_TARGET_MATERIAL_TYPE;
				relationship = lang.mixin(new Relationship(), {
					m_typeNode: "MaterialType"
				});
			}

			this.insertField(lang.mixin(new Field(), {
				m_label: fieldLabel,
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_bRequired: true,
				bPersist: true,
				m_relationship: relationship
			}), 0);

			this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_MATERIAL_NAME,
				m_typeControl: def.FIELD_TEXT
			}), 0);

			if (this.defView.m_formData.HasPlacements) {
				var field = this.defView.getField(xml.ATTR_NAME);
				if (field) {
					field.m_format = types.FORMAT_SELECTION;
					field.m_typeControl = def.FIELD_FILTERING_SELECT;
					field.m_relationship = lang.mixin(new Relationship(), {
						m_url: Specification.URL_ADMIN,
						m_id: "Placements"
					});

				}
			}

			// If action issued in context of Food BOM, add Common Qty field in Placements fields
			if (this._isFoodBOMAction) {
				this.insertField(lang.mixin(new Field(), {
					m_label: "CommonQty",
					m_id: "QtyDefault",
					m_typeControl: def.FIELD_NUMBER,
				}));
			}

			// Insert header Search Fields before Material Name
			this.insertField(lang.mixin(new Field(), {
				m_label: this.SEARCH_FIELDS,
				m_typeControl: def.FIELD_COMMENT
			}), this.FIELD_MATERIAL_NAME);

			this.lastSearchFieldId = this.lastSearchFieldId || fieldLabel;

			this.insertField(lang.mixin(new Field(), {
				m_label: this.FIELD_SECTION,
				m_typeControl: def.FIELD_FILTERING_SELECT,
				m_onChange: lang.hitch(this, this.onChangeSection)
			}), xml.ATTR_NAME);

			// Insert header Placement Fields after last Search field name
			this.defView.addFieldAfter(lang.mixin(new Field(), {
				m_label: this.PART_MATERIAL_FIELDS,
				m_typeControl: def.FIELD_COMMENT
			}), this.lastSearchFieldId);

			this.inherited(arguments);
		}
	});
});